"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AvatarRedirect = _interopRequireDefault(require("./AvatarRedirect"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _AvatarRedirect.default)('google', 'googleId');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/lib/sources/Google.js
// module id = 2187
// module chunks = 0